import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v2/investment-type', { params });
  },
  create(data) {
    return axios.post('/v2/investment-type', data);
  },
  update(id, params) {
    return axios.patch(`/v2/investment-type/${id}`, params);
  },
  delete(id) {
    return axios.delete(`/v2/investment-type/${id}`);
  }
};
